// extracted by mini-css-extract-plugin
export var address = "footer-module--address--ba3c5";
export var belowText = "footer-module--below-text--50ef6";
export var container = "footer-module--container--f3aab";
export var containerOne = "footer-module--container-one--e64b6";
export var footerContainer = "footer-module--footer-container--6a882";
export var footerLogo = "footer-module--footer-logo--f5c1e";
export var headerLogo = "footer-module--header-logo--a8ea9";
export var mainContainer = "footer-module--main-container--0b87f";
export var privacyNotice = "footer-module--privacy-notice--fc37f";